module.exports = __webpack_public_path__ + "img/4.c6e7895d.jpg";